<template>
  <section id="add-lab-user-account" class="case-creation">
    <div class="container-sm">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">
                {{ isNewUser ? "Add User" : "Update User" }}
              </h3>
            </div>
          </div>
          <div
            class="case-creation__body pb-0"
            v-loading.fullscreen="loading"
            :element-loading-text="loadingText"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <el-form ref="form" v-model="formData" class="vue-form">
              <el-row
                :gutter="20"
                v-if="
                  (formData.hospitals || formData.lab) && formData.user_type
                "
              >
                <el-col :xl="3" :lg="3" :md="12" :sm="12" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> User Type </label>
                      <el-select
                        placeholder="Select User Type"
                        v-model="formData.user_type"
                        @change="checkUserType"
                        :disabled="!isNewUser"
                      >
                        <el-option
                          v-for="(type, index) of userTypes"
                          :key="index"
                          :value="type.value"
                          :label="type.name"
                        ></el-option>
                      </el-select>

                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors && getUserAccountErrors.user_type
                        "
                      >
                        {{ getUserAccountErrors.user_type }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="roles">Roles <span class="star">*</span></label>
                      <el-select
                        id="roles"
                        v-model="formData.roles"
                        placeholder="Select Roles"
                        filterable
                        multiple
                        collapse-tags
                        :disabled="isRestrictedUserType"
                      >
                        <el-option
                          v-for="role in userTypes"
                          :key="role.value"
                          :value="role.value"
                          :label="role.name"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        First Name
                        <span class="star">*</span>
                      </label>

                      <el-input
                        type="text"
                        v-model="formData.first_name"
                        placeholder="Enter First Name"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors &&
                          getUserAccountErrors.first_name
                        "
                      >
                        {{ this.getUserAccountErrors.first_name }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Last Name
                        <span class="star">*</span>
                      </label>

                      <el-input
                        type="text"
                        v-model="formData.last_name"
                        placeholder="Enter Last Name"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors && getUserAccountErrors.last_name
                        "
                      >
                        {{ this.getUserAccountErrors.last_name }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Email
                        <span class="star">*</span>
                      </label>

                      <el-input
                        type="email"
                        class="email-lower"
                        v-model="formData.email"
                        placeholder="Enter Email"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors && getUserAccountErrors.email
                        "
                      >
                        {{ this.getUserAccountErrors.email }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Phone
                        <span class="star">*</span>
                      </label>

                      <el-input
                        type="text"
                        v-model="formData.phone"
                        placeholder="Enter Phone"
                        maxlength="10"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors && getUserAccountErrors.phone
                        "
                      >
                        {{ getUserAccountErrors.phone }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="5" :lg="5" :md="12" :sm="12" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        User Name
                        <span class="star">*</span>
                      </label>

                      <el-input
                        type="text"
                        v-model="formData.username"
                        placeholder="User Name"
                      >
                        <template #append>
                          <b>{{ formData.code }}</b>
                        </template>
                      </el-input>

                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors && getUserAccountErrors.username
                        "
                      >
                        {{ this.getUserAccountErrors.username }}
                      </p>
                      <span
                        class="err"
                        v-if="
                          getUserAccountErrors &&
                          getUserAccountErrors.critical_error
                        "
                        >{{ this.getUserAccountErrors.critical_error }}</span
                      >
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="case-creation__actions">
          <ul class="list">
            <li>
              <button
                type="button"
                class="btn cancel-button"
                @click="cacelUserCreate"
              >
                Cancel
              </button>
            </li>
            <li>
              <button
                v-loading="loading"
                type="button"
                class="btn save-button"
                @click="onSubmit"
                :disabled="loading"
              >
                {{ isNewUser ? "Add Account" : "Update Account" }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "profile",
  mixins: [UserPermissionsHelper, AppHelper],
  computed: {
    ...mapGetters("userAccounts", [
      "getUserAccountAddStatus",
      "getUserAccountUpdateStatus",
      "getUserAccountErrors",
      "getUserAccountDataById",
    ]),
    ...mapGetters("labs", ["getSingleLab"]),
  },
  data() {
    return {
      loading: false,
      loadingProfile: false,
      states: {},
      isNewUser: true,
      userId: "",
      formData: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        username: "",
        user_type: "",
        roles: [""],
        default_role: "",
        hospitals: [],
        physician: "",
        lab: this.$route.params.lab_id,
        code: "",
      },

      userTypes: [
        {
          name: "Billing Representative",
          value: "BILLING_REPRESENTATIVE",
        },
        {
          name: "Lab Manager",
          value: "LAB_MANAGER",
        },
        {
          name: "Admin",
          value: "LAB_ADMIN",
        },

        {
          name: "Lab Assistant",
          value: "LAB_DATA_ASSISTANT",
        },
        {
          name:"Lab Data Admin",
          value:"LAB_DATA_ADMIN"
        },
        {
          name: "QC Manager",
          value: "QC_MANAGER",
        },
        {
          value: "AR_LEAD",
          name: "AR-Lead",
        },
        {
          value: "AR_EXECUTIVE",
          name: "AR-Excutive",
        },
        { value: "CP_LEAD", name: "CP-Lead" },
        { value: "CODING_LEAD", name: "Coding-Lead" },
        { value: "CODING_EXECUTIVE", name: "Coding-Excutive" },
        { value: "POSTING_EXECUTIVE", name: "Posting-Excutive" },
        { value: "SR_FTE", name: "Senior-FTE" },
      ],

      defaultDateOptions: {
        disabledDate(date) {
          const disableNewDates = date.setDate(date.getDate());
          return disableNewDates > new Date();
        },
      },
      disableUserAdd: false,
      loadingText: "",
    };
  },
  created() {},
  async mounted() {
    this.userId = this.$route.params.user_id;
    await this.checkAndFetchUser();
    this.checkUserTypeAndFetchData();

    this.refreshErrors();
  },
  methods: {
    convertToLower(value) {
      if (value) {
        this.patientInformationFormData.email = value.toLowerCase();
      }
    },

    async checkUserTypeAndFetchData() {
      this.fetchLabs();
    },

    async checkAndFetchUser() {
      if (this.userId) {
        this.loading = true;
        this.isNewUser = false;
        this.loadingText = "Fetching data.........";

        await this.$store.dispatch("userAccounts/fetchUserAccountById", {
          id: this.userId,
        });
        let data = { ...this.getUserAccountDataById };
        if (data) {
          this.setUserDetailsInForm(data);
        }
        this.loading = false;
      }
    },

    async checkUserType(userType) {
      if (this.isNewUser) {
        if (userType === "HOSPITAL_PHYSICIAN") {
          if (this.formData.hospitals) {
            await this.fetchAllPhysiciansByHospital(this.formData.hospitals);
          }
        }
        this.formData.first_name = "";
        this.formData.last_name = "";
        this.formData.email = "";
        this.formData.phone = "";
        this.formData.username = "";
      }
    },

    async refreshErrors() {
      await this.$store.dispatch("userAccounts/refreshErrors");
    },
    fillFields() {},

    async fetchLabs() {
      await this.$store.dispatch(
        "labs/fetchSingleLab",
        this.$route.params.lab_id
      );
      this.formData.code = "." + this.getSingleLab.lab_code.toLowerCase();
    },

    async onSubmit() {
      if (this.isNewUser) {
        await this.addAccount();
      } else {
        await this.updateAccount();
      }
    },
    async addAccount() {
      this.disableUserAdd = true;
      this.loading = true;

      try {
        let params = {
          first_name: this.formData.first_name.trim(),
          last_name: this.formData.last_name.trim(),
          email: this.formData.email.toLowerCase(),
          lab: this.formData.lab,
          phone: this.formData.phone,
          username:
            this.formData.username && this.formData.username.trim()
              ? this.convertToLowerCase(
                  this.formData.username + this.formData.code
                )
              : undefined,
          user_type: this.formData.user_type,
          roles: Array.from(new Set(this.formData.roles && this.formData.roles.length
            ? this.formData.roles
            : [this.formData.user_type])),
          default_role: this.formData.default_role || this.formData.user_type,
          hospitals: this.formData.hospitals,
          physician: this.formData.physician
            ? this.formData.physician
            : undefined,
          settings: {
            email_events: [],
          },
        };

        params = this.getFormattedValues(params);
        if (this.emailEventsData && this.emailEventsData.length) {
          const userSelectedEvents = this.emailEvents.filter((eventData) => {
            return this.emailEventsData.indexOf(eventData.name) != -1;
          });
          if (userSelectedEvents && userSelectedEvents.length) {
            params["settings"]["email_events"] = userSelectedEvents;
          }
        } else {
          params["settings"]["email_events"] = [];
        }

        await this.$store.dispatch("userAccounts/addUserAccount", params);

        if (this.getUserAccountAddStatus) {
          successNotification("User Account added successfully");
          this.goBack();
        } else if (
          this.getUserAccountErrors &&
          this.getUserAccountErrors.critical_error
        ) {
          errorNotification(this.getUserAccountErrors.critical_error);
        }
      } catch (err) {
        console.log(err);
        errorNotification("Error at Adding user account");
      }
      this.loading = false;
      this.disableUserAdd = false;
    },
    async updateAccount() {
      this.disableUserAdd = true;
      this.loading = true;

      try {
        let params = {
          id: this.userId,
          first_name: this.formData.first_name,
          last_name: this.formData.last_name,
          email: this.formData.email.toLowerCase(),
          lab: this.formData.lab,
          phone: this.formData.phone,
          username:
            this.formData.username && this.formData.username.trim()
              ? this.convertToLowerCase(this.formData.username)
              : undefined,
          user_type: this.formData.user_type,

          physician: this.formData.physician
            ? this.formData.physician
            : undefined,
          settings: {
            email_events: [],
          },
        };

        if (this.formData.hospitals.length) {
          params.hospitals = [this.formData.hospitals];
        }

        params = this.getFormattedValues(params);
        if (this.emailEventsData && this.emailEventsData.length) {
          const userSelectedEvents = this.emailEvents.filter((eventData) => {
            return this.emailEventsData.indexOf(eventData.name) != -1;
          });
          if (userSelectedEvents && userSelectedEvents.length) {
            params["settings"]["email_events"] = userSelectedEvents;
          }
        } else {
          params["settings"]["email_events"] = [];
        }

        await this.$store.dispatch("userAccounts/updateUserAccount", params);

        if (this.getUserAccountUpdateStatus) {
          successNotification("User Account Updated Successfully");
          this.goBack();
        } else if (
          this.getUserAccountErrors &&
          this.getUserAccountErrors.critical_error
        ) {
          errorNotification(this.getUserAccountErrors.critical_error);
        }
      } catch (err) {
        console.log(err);
        errorNotification("Error at Updating user account");
      }
      this.loading = false;
      this.disableUserAdd = false;
    },

    goBack() {
      if (
        this.$route.params &&
        this.$route.params.user_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        let query = this.$route.query;
        let redirectRoute = this.$route.query.redirectRoute;
        delete query.redirectRoute;
        this.$router.push({
          name: redirectRoute,
          query: query,
        });
      } else {
        this.$router.push({
          name: "LabUsers",
          query: { ...this.$route.query },
        });
      }
    },

    setUserDetailsInForm(data) {
      this.formData.first_name = data.first_name;
      this.formData.last_name = data.last_name;
      this.formData.email = data.email;
      this.formData.lab = data.lab ? data.lab._id : "";
      this.formData.hospitals = data.hospital ? data.hospital._id : "";
      this.formData.physician = data.physician || "";
      this.formData.user_type = data.user_type;
      this.formData.phone = data.phone;
      let userNameParts = data.username;
      if (userNameParts && userNameParts.length > 1) {
        let code = userNameParts[userNameParts.length - 1];
        userNameParts;

        this.formData.username = userNameParts;
        this.formData.code = "." + code;
      } else {
        this.formData.code = "";
      }
    },
    async cacelUserCreate() {
      this.$router.push({
        name: "LabUsers",
        params: {
          lab_id: this.$route.params.lab_id,
        },
      });
    },

    setUsername() {
      this.formData.username = this.first_name + this.last_name;
    },
    convertToLowerCase(data = "") {
      return data.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
#add-lab-user-account {
  .el-form-item__content .el-input-group {
    vertical-align: initial;
  }
}
</style>
